"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _removeSpaces = require("../../utils/removeSpaces");
require("./StoreFrontCard.scss");
var _lodash = require("lodash");
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _Image = _interopRequireDefault(require("../Image/Image"));
var _Button = _interopRequireDefault(require("../Button/Button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const StoreFrontCard = _ref => {
  let {
    content
  } = _ref;
  const {
    mouse
  } = (0, _useMouse.default)();
  const [quantity, setQuanity] = (0, _react.useState)(0);
  const [cart, setCart] = (0, _react.useState)(null);
  const increaseQuantity = () => {
    setQuanity(quantity + 1);
  };
  const decreaseQuantity = () => {
    if (quantity === 0) {
      return;
    } else if (quantity > 0) {
      setQuanity(quantity - 1);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ftg-storefront-card"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ftg-storefront-card__title"
  }, content?.title && /*#__PURE__*/_react.default.createElement("h1", {
    className: "ftg-storefront-card__title-text"
  }, content.title)), (content?.image?.url || content?.image?.src || content?.image?.Image) && /*#__PURE__*/_react.default.createElement(_Image.default, {
    GatsbyImage: content?.GatsbyImage,
    image: content?.image?.image ? content?.image?.image : null,
    className: "ftg-storefront-card__image",
    src: (0, _removeSpaces.removeSpaces)(content?.image?.url || content?.image?.src),
    alt: content?.image?.altText
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ftg-storefront-card__details"
  }, content?.header && /*#__PURE__*/_react.default.createElement("p", {
    className: "ftg-storefront-card__header-text"
  }, content.header), content?.text && /*#__PURE__*/_react.default.createElement("p", {
    className: "ftg-storefront-card__description-text"
  }, content.text), content?.link?.text && /*#__PURE__*/_react.default.createElement("a", {
    // id={uniqueId("id-")}
    tabIndex: mouse ? "" : "0",
    className: mouse ? "ftg-storefront-card__link" : "ftg-storefront-card__link tabFocus",
    href: content?.link?.url,
    target: "_blank"
  }, content.link.text)), /*#__PURE__*/_react.default.createElement("div", {
    className: `ftg-storefront-card__pricing ${!content.quantityTitle ? "ftg-storefront-card__pricing-item" : ""}`
  }, content?.priceTitle && /*#__PURE__*/_react.default.createElement("p", {
    className: "ftg-storefront-card__price-title"
  }, content.priceTitle), content?.price && /*#__PURE__*/_react.default.createElement("p", {
    className: "ftg-storefront-card__price"
  }, content.price), content?.quantityTitle && /*#__PURE__*/_react.default.createElement("p", {
    className: "ftg-storefront-card__quantity-title"
  }, content.quantityTitle), content?.quantityTitle && /*#__PURE__*/_react.default.createElement("p", {
    className: "ftg-storefront-card__quantity"
  }, quantity), content?.quantityTitle && /*#__PURE__*/_react.default.createElement("div", {
    className: "ftg-storefront-card__icon"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "ftg-storefront-card__minus",
    onClick: () => decreaseQuantity()
  }, "-")), content?.quantityTitle && /*#__PURE__*/_react.default.createElement("div", {
    className: "ftg-storefront-card__icon"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "ftg-storefront-card__plus",
    onClick: () => increaseQuantity()
  }, "+"))), content?.button?.text && content?.button?.url && /*#__PURE__*/_react.default.createElement(_Button.default, {
    Link: content?.button?.Link,
    url: content?.button?.url,
    text: content?.button?.text,
    className: mouse ? "ter-button--primary-1" : "ter-button--primary-1 tagFocus"
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "ftg-storefront-card__delivery-estimation"
  }, content?.deliveryEstimation));
};
var _default = StoreFrontCard;
exports.default = _default;